<template>
  <div class="carListChildren">
    <div class="listTitle" v-if="list.length > 0">
      <!-- <img src="../../../assets/images/mall/hotCar.png" alt=""> -->
      <h1>{{ title }}</h1>
      <span @click="toMallCar" v-if="childrenAd.code === 'hot' && list.length > 8">
        <i id="triangle-topleft"></i>
        查看全部
      </span>
    </div>
    <div
      class="listPanel"
      :style="{
        height: list.length > 4 ? '645px' : '315px'
      }"
    >
      <div v-if="childrenAd && childrenAd.adPicture" @click="toAdlink">
        <div
          class="commodityFirst"
          :style="{
            'background-image': `url(${childrenAd.adPicture})`,
            height: list.length > 4 ? '645px' : '315px'
          }"
        ></div>
      </div>

      <div
        class="productList"
        v-if="list.length > 0"
        :style="{
          width: childrenAd && childrenAd.adPicture ? '1100px' : '100%'
        }"
      >
        <!-- productCard组件 -->
        <ProductCard
          v-for="(item, i) in list.slice(0, childrenAd && childrenAd.adPicture ? 8 : 10)"
          :key="i"
          :info="item"
          :type="true"
          ref="productCard"
          :beforeOpen="closeAll"
          :style="{
            'margin-left': childrenAd && childrenAd.adPicture ? '15px' : parseInt(i / 5) === i / 5 ? '0' : '15px'
          }"
        ></ProductCard>

        <!-- <div class="find-more" v-if="list.length < 8" @click="toMallCar">
            <img src="@/assets/images/mall/find-more.png" alt="" />
            <p>查看全部</p>
          </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import ProductCard from '@/components/business/mall/productCard'
export default {
  name: '',
  data() {
    return {
      title: '限时抢购',
      childrenAd: {},
      list: []
    }
  },
  props: {
    carListChildren: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    const childrenAd = this.carListChildren
    if (childrenAd) {
      this.title = childrenAd.title
      this.childrenAd = childrenAd
    }
    this.list = childrenAd
      ? childrenAd.itemList.filter((item) =>
          item.activityTag
            ? item.activityTag.activityTypeCode !== 'groupPurchase' && item.activityTag.activityTypeCode !== 'auction'
            : true
        ) || []
      : []
  },
  components: {
    ProductCard
  },
  methods: {
    toMallCar() {
      this.$router.push({
        path: '/seller/mallCar'
      })
    },
    closeAll() {
      this.$refs.productCard.map((comp, i) => {
        comp.closeCode(this.list[i])
      })
    },
    toAdlink() {
      if (this.childrenAd.adLink) {
        window.location.href = this.childrenAd.adLink
      }
    }
  }
}
</script>

<style lang="scss">
.carListChildren {
  width: 1360px;
  min-width: 1200px;
  margin: 0px auto;
}
.listTitle {
  width: 100%;
  height: 70px;
  font-size: 22px;
  font-family: 'NotoSansHans-Bold';
  font-weight: bold;
  // margin-bottom: 20px;
  padding-top: 12px;
  // background-color: lightblue;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > img {
    width: 128px;
    height: 27px;
  }
  h1 {
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 42px;
    padding-left: 24px;
    position: relative;
  }
  h1:after {
    content: '';
    width: 4px;
    height: 24px;
    background: #c6001f;
    position: absolute;
    left: 0;
    top: 10px;
  }
  span {
    display: inline-block;
    width: 130px;
    height: 34px;
    font-size: 18px;
    font-weight: 400;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #ffffff;
    background: #000000 url('../../../assets/images/mall/see-more-arrow.png') no-repeat 110px center;
    background-size: 14px;
    #triangle-topleft {
      width: 0;
      height: 0;
      border-top: 34px solid#F5F5F5;
      border-right: 12px solid transparent;
      margin-right: 16px;
    }
  }
  // span:hover {
  //   background: url('../../../assets/images/mall/more-check.png') no-repeat right center;
  //   background-size: 20px 20px;
  // }
}
.listTitle > span:first-child {
  font-size: 32px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* background-color: lightcoral; */
  padding: 0px;
}
.listTitle > span:last-child {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.listPanel > span:last-child {
  font-size: 20px;

  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.listTitle > span > img {
  margin-left: 6px;
}
.listPanel {
  width: 100%;
  a {
    width: 100%;
    height: 100%;
  }
  // height: 645px;
}
.productList {
  width: 1100px;
  height: 100%;
  // height: 645px;
  /* padding-left: 15px; */
  float: left;
  /* background-color: lightgreen; */
  .find-more {
    width: 260px;
    height: 315px;
    position: relative;
    float: left;
    margin-left: 15px;
    margin-bottom: 14px;
    transition: all 0.4s linear;
    background: rgba(255, 255, 255, 1);
    img {
      width: 44px;
      height: 44px;
      margin: 130px 108px 10px;
    }
    p {
      text-align: center;
      font-size: 16px;
      color: rgba(102, 102, 102, 1);
      line-height: 20px;
    }
  }
  .find-more:hover {
    /* cursor: pointer; */
    top: -3px;
    box-shadow: 0px 4px 10px 0px rgba(27, 50, 71, 0.22);
  }
}
.productList-best {
  width: 1360px;
  height: 645px;
  /* background-color: lightsalmon; */
  .productCard:nth-child(6),
  .productCard:nth-child(1) {
    margin-left: 0px;
  }
  .productCard {
    width: 260px;
    height: 315px;
    position: relative;
    float: left;
    margin-left: 15px;
    margin-bottom: 20px;
    background: white;
    text-align: center;
    transition: all 0.2s linear;
    .Deposit {
      position: absolute;
      width: 60px;
      height: 66px;
      top: 0;
      right: 0;
    }
    .secondKill {
      background-image: url('../../../assets/secondKill.png');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }
    &:hover {
      top: -3px;
      box-shadow: 0px 4px 10px 0px rgba(27, 50, 71, 0.22);
    }
    a {
      text-decoration: none;
    }
    .productImage2 {
      width: 260px;
      height: 150px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      overflow: hidden;
      margin-bottom: 19px;
    }
    .productImage3 {
      width: 260px;
      height: 315px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      overflow: hidden;
      margin-bottom: 19px;
    }
    .productName2 {
      margin-top: 10px;
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 2px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
      color: #000000;
    }

    .productDiscount2 {
      //单行显示多余隐藏
      height: 22px;
      width: 80%;
      margin-top: 5px;
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
      line-height: 20px;
    }
    .productPrice {
      font-size: 16px;
      font-weight: 500;
      color: #c6001f;
      line-height: 22px;
    }
  }
}
.commodityFirst {
  width: 260px;
  height: 100%;
  min-height: 315px;
  overflow: hidden;
  float: left;
  background: rgba(255, 255, 255, 1);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* background-color: lightcoral; */
  // box-shadow: 0px 4px 10px 0px rgba(27, 50, 71, .22);
  img {
    width: 100%;
  }
}
.advertize-img {
  width: 1360px;
  height: 200px;
  margin: 26px auto 0;
  img {
    width: 1360px;
    height: 200px;
  }
}
</style>
